// client/src/services/disputeService.js
import axios from '../utils/axiosConfig';

export const raiseDispute = (data) => axios.post('/disputes', data).then(r => r.data.dispute);
export const listDisputes = (status) => axios.get('/disputes', { params: { status } }).then(r => r.data.disputes);
export const resolveDispute = (id, data) => axios.put(`/disputes/${id}/resolve`, data).then(r => r.data);
